import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3807910"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "auth__wrapper" }
const _hoisted_4 = { class: "auth__info" }
const _hoisted_5 = { class: "auth__logo" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auth__desc" }, [
  /*#__PURE__*/_createElementVNode("p", null, "More than just one repository. This is our digital world.")
], -1))
const _hoisted_7 = { class: "auth__button" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "auth__footer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "footer__text" }, "© Gitogram from Loftschool")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Icon, { name: "logo" })
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Button, {
              text: "Authorize with github",
              icon: "GitCat",
              onClick: _ctx.authUser
            }, null, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    _hoisted_8
  ]))
}